import { TextField, InputAdornment } from "@mui/material"
import SearchIcon from '@mui/icons-material/Search';
import { useState, useEffect } from "react";
import API from "../../services/API/Tags";
import { txt } from "../../services/translation";

export default function Search({onSubmit, onTagClick}){

    const [search, setSearch] = useState('')
    const [display, setDisplay] = useState(false)
    const [tags, setTags] = useState([])

    useEffect(() => {
        API.getAll().then(r => setTags(
            Array.isArray(r.data) ? r.data : []
        ))
    }, [])


    const match = t => {
        let text = (t.type?.title + t.title).toLowerCase();
        return text.includes(search.toLocaleLowerCase())
    }

    const handleSearch = e => {
        setDisplay(true);
        return setSearch(e.target.value)
    }

    const handleTagClick = tag => {
        setDisplay(false);
        setSearch('');
        return onTagClick(tag);
    }

    const handleSubmit = e => {
        setDisplay(false);
        return onSubmit(e);
    }

    const list = tags.filter(t => match(t))

    const showTags = display && search.length > 0 && list.length > 0;

    return <form onSubmit={handleSubmit} style={{flex: 1}}>

        <TextField
            label={txt('search')}
            type='search'
            name='search'
            size='small'
            InputProps={{
                minLength: 3,
                startAdornment: <InputAdornment position='start'><SearchIcon/></InputAdornment>
            }}
            fullWidth
            value={search}
            onChange={handleSearch}
        />

        {(false && showTags) && <div className='social-search-tags'>

            <p><b>{txt('tags')}</b></p>

            {list.map(t => 
                <p 
                    key={t.id} 
                    onClick={() => handleTagClick(t)}
                    className='social-search-tag'
                >
                    {t.type?.title} : {t.title}
                </p>    
            )}

        </div>}

    </form>
}